/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Cta_LedeInputs */

const en_svc_agents_cta_lede = /** @type {(inputs: Svc_Agents_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One recent example is enough. We will tell you honestly whether an agent is the right tool.`)
};

const lv_svc_agents_cta_lede = /** @type {(inputs: Svc_Agents_Cta_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pietiek ar vienu nesenu piemēru. Godīgi pateiksim, vai aģents ir īstais rīks.`)
};

/**
* | output |
* | --- |
* | "One recent example is enough. We will tell you honestly whether an agent is the right tool." |
*
* @param {Svc_Agents_Cta_LedeInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_cta_lede = /** @type {((inputs?: Svc_Agents_Cta_LedeInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Cta_LedeInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_cta_lede(inputs)
	return en_svc_agents_cta_lede(inputs)
});